<template>
  <v-dialog v-model="show" persistent max-width="460">
    <v-card tile flat>
      <v-card-title class="headline">Kiállítás</v-card-title>
      <v-card-text>
        <template v-if="type === 1">
          Válassza ki melyik játékos menjen le a pályáról!
        </template>
        <template v-if="type === 2">
          Válassza ki melyik játékos kapjon 2x2 percet!
        </template>
        <br><br>
        {{gamedata[team === 'A' ? 'team_a_name' : 'team_b_name']}} csapat
        <br><br>
        <v-select v-model="selected"
                  class="width-100"
                  return-object
                  :items="currentTeamPlayers"
                  :item-text="(player) => player.jersey + ' ' + player.name"
                  label="Játékos"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn depressed tile @click="close">Mégsem</v-btn>
        <v-btn depressed tile color="green" @click="save" :disabled="!selected">Mentés</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '@/eventBus';
import CONSTANTS from "@/constants";

export default {
  name: 'SingleExcludeDialog',
  props: {
    gamedata: {
      type: Object,
      required: true
    },
    playersStatus: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      show: false,
      selected: null,
      player: null,
      team: '',
      time: '00:00',
      totalGameTime: 0,
      type: 1
    };
  },
  computed: {
    currentTeamPlayers() {
      if (!this.team || !this.playersStatus.active) return [];
      return this.team === 'A' ? this.playersStatus.active.A : this.playersStatus.active.B;
    }
  },
  created() {
    // Figyeljük a globális eseményt a megnyitáshoz
    eventBus.$on(CONSTANTS.ACTIONS.EXCLUDEPLAYERDIALOG, this.open);
  },
  beforeDestroy() {
    eventBus.$off(CONSTANTS.ACTIONS.EXCLUDEPLAYERDIALOG, this.open);
  },
  methods: {
    open(player, team, type = 1) {
      this.selected = null;
      // Ha player null, akkor Hivatalos személy (officialExclude hívta)
      this.player = player ? {
        id: player.id,
        jersey: player.jersey,
        name: player.name,
      } : null;

      this.team = team;
      this.time = window.stopwatch.getTotalTimeAsString();
      this.totalGameTime = window.stopwatch.getTotalTime();
      this.type = type || 1;

      this.show = true;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
    },
    close() {
      this.show = false;
      this.selected = null;
      this.player = null;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
    save() {
      if (this.type === 1) {
        if (this.player) {
          // Játékos kiállítás
          eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYER, true, this.player, this.team, this.selected);
        } else {
          // Hivatalos személy kiállítás
          eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEOFFICIAL, true, this.selected, this.team);
        }
      } else {
        // 2x2 perc logika (type === 2) - Jelenleg csak logol a régi kódban is
        console.log("Double exclude saved");
      }
      this.close();
    }
  }
}
</script>

<style scoped>
</style>
